import { z } from 'zod';

export const ClaimRewardSchema = z.object({
  rewardType: z.enum(['Coins']),
  prizeDelivery: z.enum(['DailyGift', 'StatusGiftbox']),
  rewardAmount: z.number(),
  nextAvailableAt: z.string().datetime().optional(),
});
